import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './process_icons.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'

function ProcessIcons(props) {
	const fields = props.fields
	const items = fields.items || []

	return <div>
		<ScrollAnimation styles={styles}>
			<BlockWrapper {...props} className={classNames(styles.process_icons)}>
				<div className={styles.icon_cards_wrapper}>
					{items.map((item, i) => {
						const hasHeading = !!item.heading
						const hasIcon = !!(item.icon && (item.icon.url || item.icon.src))
						const hasTitle = !!item.title
						const hasSubTitle = !!item.sub_title
						return (
							<React.Fragment key={i}>
								<div className={styles.icon_card}>
									{hasHeading && <p className={styles.heading}>{item.heading}</p>}
									{hasIcon && <Image className={styles.icon} {...item.icon} />}
									{hasTitle && <p className={styles.title}>{item.title}</p>}
									{hasSubTitle && <p className={styles.sub_title}>{item.sub_title}</p>}
								</div>
								{i < items.length - 1 && (
									<span className={styles.arrow}>
										<svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20" fill="none">
											<path d="M1.34 19.44C1.05 19.44 0.76 19.33 0.54 19.11C0.1 18.67 0.1 17.96 0.54 17.52L8.23 9.83L0.33 1.92C-0.11 1.48 -0.11 0.77 0.33 0.33C0.77 -0.11 1.48 -0.11 1.92 0.33L10.62 9.03C11.06 9.47 11.06 10.18 10.62 10.62L2.13 19.11C1.91 19.33 1.62 19.44 1.33 19.44H1.34Z" fill="#63A643"/>
										</svg>
									</span>
								)}
							</React.Fragment>
						)
					})}
				</div>
			</BlockWrapper>
		</ScrollAnimation>
	</div>
}

export default ProcessIcons